// extracted by mini-css-extract-plugin
export var assigneeBadge = "_l5-0";
export var assigneeDetails = "_l5-1";
export var assigneeInfo = "_l5-2";
export var dropdownContainer = "_l5-4";
export var dropdownImage = "_l5-5";
export var editAssigneeInfo = "_l5-3";
export var editAssigneeModalContainer = "_l5-6";
export var hidden = "_l5-8";
export var input = "_l5-7";